import { OwnershipModel } from "./ownership-model";

export class InvestmentDetails {
  hadOwnership: string = '';
  ownerships: Array<OwnershipModel> = new Array<OwnershipModel>();
}